<template>
  <div class="bankList">
      <h2>
          {{$t('bankList')}}
      </h2>
      <div class="account-btns">
          <Button type="primary" @click="toAdd()">{{$t('addBank')}}</Button>
      </div>
      <Table :columns="columns" :data="bankData" :loading="loading">
		  <template slot-scope="{ row }" slot="country">
			  <span>{{row.country | countryFilter(that)}}</span>
		  </template>
		  <template slot-scope="{ row }" slot="accountCurrency">
			  <span>{{row.accountCurrency | currencyFilter}}</span>
		  </template>
          <!-- <template slot-scope="{ row }" slot="manage">
			 <Button type="primary" @click="toAdd(row)">{{$t('edit')}}</Button>
		  </template> -->
	  </Table>
      <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
                <Page :total="total" :current="pageIndex" :page-size="pageSize" @on-change="changePage" ></Page>
            </div>
        </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'



export default {
  name: 'Home',
  data(){
    return{
        loading:false,
		isReal: 1,
        columns: [
            {
                title: this.$t('bankNameList'),
                key: 'bankName'
            },
            {
                title: this.$t('bankAccountNameList'),
                key: 'nameOnBankAccount',
                width: 200
            },
            {
                title: this.$t('bankAddressList'),
				key: 'address'
            },
            {
                title: this.$t('bankCountryList'),
				slot: 'country'
            },
            {
                title: this.$t('ibanList'),
				key: 'iban'
            },
            {
                title: this.$t('swiftList'),
				key: 'swift_BIC'
            },
            {
                title: this.$t('accountNumberList'),
                key: 'accountNumber',
                width: 180
            },
            {
                title: this.$t('sortCodeList'),
				key: 'sortCode'
            },
            {
                title: this.$t('accountCurrencyList'),
                slot: 'accountCurrency',
                width: 180
            },
            // {
            //     title: this.$t('manage'),
            //     slot: 'manage'
            // }
        ],
		countryList: [],
        bankData: [],
        that:this,
        pageIndex:1,
        pageSize:5,
        total:0,
    }
  },
    computed: {
        ...mapState(['lang','userInfo'])
    },
    filters: {
        countryFilter(val,that) {
            var common = that.countryList.filter(function (item) 
            {
                return item.value == val
            })
            return common.length > 0 ? common[0].label : ''
        },
        currencyFilter(val) {
            // console.log(val)
            switch (val) {
                case '1':
                    return "USD"
                    break;
                case '2':
                    return "EUR"
                    break;
                case '3':
                    return "GBP"
                    break;
                default:
                    break;
            }
        },
    },
    created(){
        this.getCountry()
        this.getData()
    },
    methods:{
        getCountry(){
            this.countryList = []
            this.$axios.get('/api/CreateRealAccount/Index')
            .then(async (res) => {
                // console.log(res)
                if(res.data.status == 1){
                    res.data.obj.forEach(e => {
                        let data = {
                            value:e.id.toString()
                        }
                        if(this.lang == 'zh'){
                            data.label = e.nameCN
                        }else{
                            data.label = e.name
                        }
                        this.countryList.push(data)
                    });
                }else{
                    this.$Message.error(res.data.msg)
                }
            })
            .catch((err) => {
                this.$Message.error(err.data.msg)
            })
        },
        getData(type){
			
			this.loading = true
            this.$axios.get('/api/UserInfo/GetBankList',{
				params:{
                    pageIndex:this.pageIndex,
                    pageSize:this.pageSize
				}
			})
            .then(async (res) => {
				let dt = res.data
                
				this.loading = false
                if(dt.status == 1){
                    this.bankData = dt.obj.bankList
                    this.total = dt.obj.totalCount
                }else{
                    this.$Message.error(dt.msg)
                }
            })
            .catch((err) => {
				this.loading = false
			})
        },
        toAdd(row){
            // console.log(row)
            if(row){
                this.$router.push({path:'/registerBank',query: {id:row.id}})
            }else{
                this.$router.push({path:'/registerBank'})
            }
            
        },
        changePage(val){
            this.pageIndex = val
            this.getData()
        }
    }
}
</script>
<style lang="less">
.bankList{
    width: 1440px;
    margin: 0 auto;
    height: 100%;
    position: relative;
    h2{
        margin-top: 20px;
        font-weight: normal;
        font-size: 18px;
        color: #332c2b;
        line-height: 50px;
        padding-bottom: 20px;
    }
    .account-btns{
        position: absolute;
        right: 0;
        top: 0;
    }
	.register-demo{
		display: inline-flex;
		align-items: center;
	}
	.ivu-table-tip td{
		width: auto!important;
    }
    .ivu-table-cell-slot{
        .ivu-btn-primary{
            min-width:80px;
            font-size: 14px;
            height: 40px;
        }
    }
}
</style>
